exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".eventix--dashboard--coupons--codes .strike-out {\n  text-decoration: line-through;\n}\n", ""]);

// exports
